import React from "react";
import { useState } from "react";
import { GlobalContext } from "./GlobalContext";

export const GlobalState = (props) => {

    const [loader, setLoader] = useState(false);
    const [loggedIn, setLoggedIn] = useState(localStorage.getItem('user-info') && JSON.parse(localStorage.getItem('user-info')).token ? true : false);
    const [userInfo, setUserInfo] = useState(localStorage.getItem('user-info') ? JSON.parse(localStorage.getItem('user-info')).data : {});
    const [refreshProfile, setRefreshProfile] = useState(false);
    const [showPlanScreen, setShowPlanScreen] = useState(false);
    const [lock, setLock] = useState(false);
    const [disableGeneration, setDisableGeneration] = useState(false);
    // sessionComplete is used to manage the session logout popup
    const [sessionComplete, setSessionComplete] = useState(false);
    // Sidebar threads
    const [threads, setThreads] = useState([]);
    // Generating message
    const [generating, setGenerating] = useState(false);
    const [planModal, setPlanModal] = useState(false);
    // Plans List
    const [planList, setPlanList] = useState([]);
    const [showLogin, setShowLogin] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);

// Add this to your value object



    const value = {
        loader, setLoader,
        loggedIn, setLoggedIn,
        userInfo, setUserInfo,
        sessionComplete, setSessionComplete,
        threads, setThreads,
        generating, setGenerating,
        planModal, setPlanModal,
        planList, setPlanList,
        refreshProfile, setRefreshProfile,
        showPlanScreen, setShowPlanScreen,
        lock, setLock,
        disableGeneration, setDisableGeneration,
        showLogin, setShowLogin,
        showForgotPassword, setShowForgotPassword,
    }

    return (
        <GlobalContext.Provider value={value}>
            {props.children}
        </GlobalContext.Provider>
    )

}